/**
 * Centralised AI prompt templates for the "Preguntar a tu asistente de IA" context menu.
 *
 * Each entry maps an object type (e.g. 'accountingEvent') to an i18n key and a
 * Spanish default. The hook `useAiContextMenu` resolves the template via `t()`
 * and fills `{placeholder}` tokens from the row data.
 *
 * To add a new object type:
 *   1. Add a template entry here.
 *   2. Add the corresponding i18n keys in es.json / en.json / pt.json.
 *   3. Call `useAiContextMenu({ objectType: '<key>', getPlaceholders: ... })` in the page.
 */

export interface AiPromptTemplate {
  /** i18n key for the template string */
  i18nKey: string;
  /** Default template (Spanish) — used as fallback if i18n key is missing */
  defaultTemplate: string;
}

export const AI_PROMPT_TEMPLATES: Record<string, AiPromptTemplate> = {
  accountingEvent: {
    i18nKey: 'aiContext.templates.accountingEvent',
    defaultTemplate:
      'Usando las herramientas de FX+, explícame el evento "{event_type}" del {fecha} de la operación {trade_id}: qué lo originó, qué asientos generó y por qué generó esos eventos.',
  },
  accountingEntry: {
    i18nKey: 'aiContext.templates.accountingEntry',
    defaultTemplate:
      'Usando las herramientas de FX+, explícame el asiento {entry_id} de la operación {trade_id}, evento "{event_type}" del {fecha}: qué regla contable lo generó, con qué valorización y por qué esos montos.',
  },
  valuation: {
    i18nKey: 'aiContext.templates.valuation',
    defaultTemplate:
      'Usando las herramientas de FX+, explícame la valorización (batch {batch_id}) de la operación {trade_id} ({direction} {ccy_pair}) con vencimiento {fecha_vencimiento}: qué variables de entrada se usaron para calcular el MtM y cómo se llegó al resultado.',
  },
  // Future templates:
  // trade: { ... },
  // confirmation: { ... },
  // maturity: { ... },
  // position: { ... },
};
